export default __webpack_public_path__ + "static/media/section2-guide-bar.14ed5e4e.png";